// import react libraries
import { useState } from "react";
import { useTranslation } from "react-i18next";

const SearchBar = ({placeholder, term, setSearchDataFromChild}) => {
    // translation
    const { t } = useTranslation();
    const [searchTerm, setSearchTerm] = useState(term);

    const searchedData = (e) => {
        e.preventDefault();
        // const search = searchString.replace(/[^\w\s]/gi, '');
        const searchString = e.target.value;
        setSearchTerm(searchString);
    };

    const handleSearchChanges = (e, type) => {
        e.preventDefault();
        if(type === 'refresh') {
            setSearchDataFromChild("");
            setSearchTerm("");
        } else {
            setSearchDataFromChild(searchTerm);
        }
    }

    return (
        <form onSubmit={(e) => handleSearchChanges(e)}>
            <div className="flex items-center space-x-2">
                <div className="border border-background-normal cursor-pointer bg-background-normal rounded-lg flex items-center py-2 px-2 sm:px-4">
                    <img className="w-4" src="../../../../assets/icons/search.svg" alt="search" />
                    <div className="pl-2 sm:pl-4">
                        <input className="border-none bg-background-normal focus:outline-none w-44 lg:w-80" type="text" value={searchTerm} onChange={(e) => searchedData(e)} placeholder={t(placeholder)+"..."} />
                    </div>
                    {searchTerm && (<button type="button" onClick={(e) => handleSearchChanges(e, 'refresh')} className="text-gray-normal text-lg">x</button>)}
                </div>
                <button type="submit" onClick={(e) => handleSearchChanges(e, 'last')} className="text-blue-normal bg-black-300 py-3 sm:py-2 px-4 rounded-lg capitalize font-semibold">
                    <img className="block sm:hidden w-4 h-4" src="../../../../assets/icons/table/search.svg" alt="search" />
                    <span className="hidden sm:block">{ t('search')}</span>
                </button>
            </div>
        </form>
    )
}

export default SearchBar;